// 软件版本号
export const config_version = '1.1.0'

// 后端地址
export const config_baseURL = '/api'
